// Schránka souborů společná pro plochu, Soubory a další okna: Vyjmout / Kopírovat / Vložit.
// Vložení volá storage.move (vyjmuto) nebo storage.copy (zkopírováno) – obojí dělá server.
import { core, ApiError } from '../api';
import { t, tk } from '../i18n';
import { toast } from '../components/toast';
import { events } from '../events';

export interface FileClipboard {
  ids: string[];
  cut: boolean;
}

let clip: FileClipboard | null = null;
const listeners = new Set<() => void>();

export function fileClipboard(): FileClipboard | null {
  return clip;
}

export function setFileClipboard(ids: string[], cut: boolean): void {
  clip = ids.length ? { ids, cut } : null;
  for (const l of listeners) l();
}

export function onFileClipboard(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

/** Vloží obsah schránky do složky; po vyjmutí se schránka vyprázdní, po kopírování zůstává. */
export async function pasteFileClipboard(targetFolderId: string): Promise<boolean> {
  if (!clip) return false;
  const { ids, cut } = clip;
  try {
    await core('storage', cut ? 'move' : 'copy', { ids, target: targetFolderId });
    toast(t(cut ? 'soubory.moved' : 'soubory.copied'), 'ok');
    if (cut) setFileClipboard([], false);
    events.kick();
    return true;
  } catch (e) {
    toast(tk((e as ApiError).message, (e as ApiError).params ?? undefined), 'error');
    return false;
  }
}
